import { combineReducers } from "redux";
import sisMap from "./rds_sisMap";
import layout from "./rds_layout";

export default combineReducers({
	sisMap,
	layout,
});
